module.exports = {
      id: "vikatantv-usage",
      viewBox: "0 0 25.176 25.204",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#vikatantv",
      toString: function () {
        return this.url;
      }
    }